import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import FinanceLanding from './FinanceLanding.vue'
import HomeView from './HomeView.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RootLanding',
  setup(__props) {

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})

return (_ctx: any,_cache: any) => {
  return (isFinance.value)
    ? (_openBlock(), _createBlock(FinanceLanding, { key: 0 }))
    : (_openBlock(), _createBlock(HomeView, { key: 1 }))
}
}

})